export {default as topology} from "./src/topology";



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/topojson-server/index.js
// module id = ../../../../topojson-server/index.js
// module chunks = vendor